// client/src/routes/app/bilant.tsx — SCR-LEDGER-001 „Bilanț" — the cash ledger (04 §9.2.3).
//
// The route owns the URL state and nothing else: `validateSearch` runs the ledger's schema and
// the screen reads it back typed, so a filtered ledger is shareable, survives a refresh, and
// Back is a filter-undo — every list filter of the page is a search param (D-2149).
//
// `Reports.Ledger` is the gate, and the ONLY gate. The fiscal group needed a role guard beside
// its permission because `manager` holds `Fiscal.Read` (D-1271); here the permission IS the
// audience rule — the Product Owner granted it to `owner` and `accountant` alone (D-2133) — and
// a second gate would be a place for the two to disagree. The API enforces the same code, so a
// hidden page reached by typing its URL renders SCR-SYS-403 rather than data.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { LedgerScreen } from '@/features/ledger/LedgerScreen';
import { ledgerSearchSchema, type LedgerSearch } from '@/features/ledger/search';

export const Route = createFileRoute('/app/bilant')({
  validateSearch: ledgerSearchSchema,
  component: LedgerRoute,
});

function LedgerRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Reports.Ledger">
      <LedgerScreen
        search={search}
        onSearchChange={(next: (previous: LedgerSearch) => LedgerSearch, options) => {
          // `resetScroll: false`: `main.tsx` creates the router with `scrollRestoration: true`,
          // which puts the window back at the top the instant a search param changes — measured
          // at 801 px to 0 on a „Chirii" toggle with the filter card under the tabs. Every
          // setting of this page is a search param, so the page's own writes leave the reader
          // where they were; arriving from another page still starts at the top (D-1674).
          void navigate({ search: next, replace: options?.replace === true, resetScroll: false });
        }}
      />
    </RequirePermission>
  );
}
